import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { Buttons } from '@app/entities/models/buttons/buttons';
import { ModalManager } from '@app/services';

import { MTranslatePipe } from '@mercadona/core/translate';

import { PtrabTwoFactorCardComponent } from '../../two-factor-card/two-factor-card.component';

@Component({
  selector: 'app-ptrab-second-fa-contact',
  imports: [MTranslatePipe, PtrabTwoFactorCardComponent],
  templateUrl: './second-fa-contact.component.html',
  styleUrls: ['./second-fa-contact.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SecondFaContactComponent {
  readonly #modalManager = inject(ModalManager);

  readonly buttons: Buttons[] = [
    {
      text: 'TWO_FACTOR.NEW_PHONE.BUTTON.NOTICE',
      enabled: true,
      onClick: () => this.#modalManager.dismissMatModal()
    }
  ];
}
